

















import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator';

interface Measure {
    name: string
    symbol: string
}

/**
 * Campo de medidas
 *
 * @author Alejandro G. Riaño <agutierrez@softcontro.es>
 */
@Component
export default class SizeInput extends Vue {
    /**
     * Etiqueta del Input
     */
    @Prop({type: String, default: 'Introduce un tamaño'})
    public label: string

    /**
     * Formato del tamaño, puede ser (Npx, Nrem, Nem, N%)
     *
     * @var { string }
     */
    @Prop({type: String, default: ''})
    public value: string

    /**
     * Lista de medidas compatibles
     */
    public measures = [
        { name: 'Pixeles', symbol: 'px'},
        { name: 'Porcentaje', symbol: '%'},
        { name: 'Rem', symbol: 'rem'},
        { name: 'Em', symbol: 'em'},
    ]

    /**
     * Observa el valor actualizado por el componente padre para actualizar
     * el valor interno del campo.
     */
    @Watch('value', {immediate: true})
    public watchValue (value: string) {
        // El valor ha cambiado, ahora esta vacío, el campo es limpiado también
        if (!value) {
            return this.size = ''
        }

        const match = value.match(/(\d*\.?\d+)\s?(px|em|ex|%|in|cn|mm|pt|pc+)/im)
        // El formato introducido no es válido
        if (!match || match.length !== 3) {
            return this.size = ''
        }

        match.shift()
        const [ size, measureSymbol ] = match
        const measure = this.measures.find(m => m.symbol === measureSymbol)
        // Si la medida del formato no se encuentra dentro de las medidas permitidas
        // por el componente el proceso es detenido. No se puede aceptar el valor
        if (!measure) {
            return this.size = ''
        }

        this.size = size
        this.measure = measure
    }

    /**
     * Método ejecutado cuando el input lanza el evento @input
     *
     * @param value
     */
    public onInput (value: any) {
        this.size = value
        this.$emit('input', `${value}${this.measure?.symbol}`)
    }

    public measure: Measure | null = null
    public size = ''

    public created () {
        this.measure = this.measures[0]
    }
}
